module.exports = __webpack_public_path__ + "static/media/arrow-circle-down.6227d124.svg";